// Mobile menu interaction fixes
document.addEventListener("DOMContentLoaded", function () {
  // Immediately ensure the page is responsive
  document.documentElement.style.setProperty(
    "--mobile-page-load-state",
    "ready"
  );

  // Fix for the captcha script error
  if (window.Shopify && window.Shopify.captcha) {
    try {
      // Create a safe wrapper for the captcha object
      var originalCaptcha = window.Shopify.captcha;
      var safeProtect = function () {
        try {
          if (originalCaptcha && originalCaptcha.protect) {
            return originalCaptcha.protect.apply(originalCaptcha, arguments);
          }
          return null;
        } catch (e) {
          console.log("Captcha error safely handled");
          return null;
        }
      };

      // Only assign if the property isn't already defined and not already fixed
      if (!window.Shopify._fixedCaptcha && !window.Shopify.captcha.protect) {
        window.Shopify.captcha.protect = safeProtect;
        window.Shopify._fixedCaptcha = true;
      }
    } catch (e) {
      console.log("Error fixing captcha:", e);
    }
  }

  // Fix menu interaction
  fixMenuInteraction();

  // Remove loaders that might be stuck
  removeStuckLoaders();

  // Make page fully interactive even if some scripts are still loading
  forcePageInteractivity();
});

// Fix menu interaction issues
function fixMenuInteraction() {
  // Find menu buttons by various possible selectors
  const selectors = [
    ".header__icon--menu", // Specific mobile menu toggle
    ".header__mobile-toggle", // Another possible mobile toggle selector
    '[data-action="open-drawer"]', // Drawer open actions
    ".js-mobile-nav-toggle", // JS based toggles
  ];

  const menuButtons = document.querySelectorAll(selectors.join(","));
  let touchStartTime = 0;
  const TOUCH_THRESHOLD = 200; // ms threshold to distinguish tap from scroll

  menuButtons.forEach((button) => {
    if (button.getAttribute("data-menu-fixed") === "true") return;

    // Mark as fixed to avoid double processing
    button.setAttribute("data-menu-fixed", "true");

    // Ensure pointer events work
    button.style.pointerEvents = "auto";

    // Use a single touchstart/touchend pair for better touch handling
    button.addEventListener(
      "touchstart",
      function (e) {
        touchStartTime = Date.now();
      },
      { passive: true }
    );

    button.addEventListener("touchend", function (e) {
      const touchEndTime = Date.now();
      const touchDuration = touchEndTime - touchStartTime;

      // Only trigger if it was a quick tap (not a scroll)
      // AND it's actually one of the designated menu toggles
      if (touchDuration < TOUCH_THRESHOLD) {
        // Check if the clicked element *is* one of the menu toggles we selected
        const isMenuToggle = Array.from(menuButtons).includes(this);

        if (isMenuToggle) {
          e.preventDefault(); // Prevent default only for menu toggles
          e.stopPropagation(); // Stop propagation to avoid triggering other handlers

          // Small delay to ensure proper event order
          setTimeout(() => {
            // Dispatch a click event ONLY on the menu toggle
            const event = new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            });
            this.dispatchEvent(event);
          }, 10);
        }
      }
    });

    // Keep click handler for non-touch devices
    // We don't need to prevent default here anymore as the touchend handler handles it
    // button.addEventListener("click", function (e) {
    //   if (e.pointerType === "touch") {
    //     // Ignore click events from touch to prevent double-firing
    //     e.preventDefault();
    //     return;
    //   }
    // });
  });
}

// Remove stuck loaders
function removeStuckLoaders() {
  const removeLoaders = () => {
    const loaders = document.querySelectorAll(
      '[aria-busy="true"], [loading="true"], [data-loading="true"], .is-loading'
    );
    loaders.forEach((loader) => {
      loader.removeAttribute("aria-busy");
      loader.removeAttribute("loading");
      loader.removeAttribute("data-loading");
      loader.classList.remove("is-loading");
    });
  };

  // Run immediately and again after 2 seconds
  removeLoaders();
  setTimeout(removeLoaders, 2000);
  setTimeout(removeLoaders, 5000);
}

// Force page interactivity
function forcePageInteractivity() {
  // Add styles to ensure the page is interactive
  const style = document.createElement("style");
  style.textContent = `
    body {
      pointer-events: auto !important;
      opacity: 1 !important;
      visibility: visible !important;
    }

    /* Apply pointer events broadly but allow overrides */
    button,
    a,
    [role="button"],
    [onclick],
    [data-action] {
      pointer-events: auto !important;
      cursor: pointer !important;
      touch-action: manipulation !important;
    }

    /* Ensure that overlay elements don't block interaction but preserve mobile menu */
    .loading-overlay,
    .predictive-search,
    .loading-overlay__spinner {
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
      display: none !important;
    }

    /* Preserve mobile menu visibility when open (using styles from new-header.liquid) */
    .header__mobile-menu[aria-hidden="false"] {
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
      transform: translateY(0) !important;
      display: block !important;
    }
  `;
  document.head.appendChild(style);

  // Periodically check if the page is still responsive - REMOVED
  // setInterval(() => {
  //   document.body.style.pointerEvents = "auto";
  // }, 1000);
}
